import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from 'src/app/core/guards/auth-guard.service';
import { CspondemandComponent } from './cspondemand.component';
import { DocumentationViewComponent } from 'src/app/core/documentation-view/documentation-view.component';
import { CspondemandNavigationComponent } from './cspondemand-navigation/cspondemand-navigation.component';


const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        component: CspondemandNavigationComponent,
        outlet: 'sidenav',
        data: { animation: 'isLeft' }
      },
      {
        path: '',
        component: CspondemandComponent,
        children: [
          {
            path: '',
            component: DocumentationViewComponent,
            outlet: ''
          }
        ]
      },
      {
        path: 'downloads',
        component: CspondemandComponent,
        children: [
          {
            path: '',
            component: DocumentationViewComponent,
            outlet: 'documentation'
          }
        ]
      },
  ]
  }];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class CspondemandRoutingModule { }